var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white h-screen w-full absolute flex justify-center flex justify-center top-0 left-0 items-center"},[_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }